export const GET_USER_DATA = 'itbi-cidadao/user/GET_USER_DATA';

export const USER_EXISTS_VALIDATION =
  'itbi-cidadao/user/USER_EXISTS_VALIDATION';

export const LOAD_USER_PROFILE = 'LOAD_USER_PROFILE';

export const ACESSO_CIDADAO_PERMITIDO_VALIDATION =
  'itbi-cidadao/user/ACESSO_CIDADAO_PERMITIDO_VALIDATION';

export const ENVIO_DOCUMENTOS_HABILITADO_VALIDATION =
  'itbi-cidadao/user/ENVIO_DOCUMENTOS_HABILITADO_VALIDATION';
